<template>
  <div class="page">
    <div class="header-menu">
      <navBar v-model="objSave"></navBar>
    </div>
    <div class="page-content">
        <!-- <iframe src="https://mp.weixin.qq.com/s/JsVkJdcbaBAyTYy9crIuIA"></iframe> -->
    </div>
  </div>
</template>
<style scoped>
  .header-menu {
    background-color: #12a3ff;
  }

</style>
<script>
  import navBar from '../modules/navBar.vue'
  export default {
    data() {
      return {
        objSave: {
          centerTitle: '',
          rightTitle: {}
        },
      }
    },
    components: {
      navBar
    }
  }

</script>
